import { makeAutoObservable } from 'mobx';
import { AttendeeEntity } from '../attendee-entity/attendee-entity';
import { AttendeeConnectionVariant, AttendeeStatus } from '../../../constans/attendee-enums';
import { sendChangeConnectionStatusAttendeeCommand } from '../../../api/dao/attendee-dao';
import LiveStreamStatusStore from '../../live-stream-status-store/live-stream-status-store';
import { getLiveStreamStatusStore } from '../../live-stream-status-store/live-stream-status-store-instance';
import { LiveCommands, createChangeConnectionStatusAttendeeCommandObject } from '../../../utils/helpers/commands-helpers';
import { getPodiumInfoStore } from '../../podium-info-store/podium-info-store-instance';
import PodiumInfoStore from '../../podium-info-store/podium-info-store';

interface IAttendeeConnectionControlService {
    shouldShowConfirmationModal: boolean;
    onConnectionAttendeeAction: (attendee: AttendeeEntity) => void;
    confirmAttendeeStatusChange: () => void;
    closeConfirmationModal: () => void;
}

class AttendeeConnectionControlService implements IAttendeeConnectionControlService {
  private showConfirmationModal: boolean;
  private confirmationVariant: AttendeeConnectionVariant | null;
  private attendee: AttendeeEntity;

  constructor (
    private readonly liveStreamStatusStore: LiveStreamStatusStore = getLiveStreamStatusStore(),
    private readonly podiumInfoStore: PodiumInfoStore = getPodiumInfoStore(),
  ) {
    makeAutoObservable(this);
    this.showConfirmationModal = false;
    this.confirmationVariant = null;
  }

  get shouldShowConfirmationModal (): boolean {
    return this.showConfirmationModal;
  }

  get modalVariant (): AttendeeConnectionVariant {
    return this.confirmationVariant!;
  }

  get selectedAttendeeViewerId (): string {
    return this.attendee?.getViewerId();
  }

  public onConnectionAttendeeAction = (attendee: AttendeeEntity): void => {
    if (attendee.isEntityLocked()) return;

    this.showConfirmationModal = true;
    this.confirmationVariant = attendee.getAttendeeStatus() === AttendeeStatus.ACTIVE
      ? AttendeeConnectionVariant.DISCONNECT
      : AttendeeConnectionVariant.RECONNECT;
    this.attendee = attendee;
  };

  public confirmAttendeeStatusChange = (): void => {
    const livePresentationId = this.liveStreamStatusStore.getLivePresentationId();
    const presentationId = this.podiumInfoStore.getPresentationId();
    this.showConfirmationModal = false;

    if (this.confirmationVariant === AttendeeConnectionVariant.DISCONNECT) {
      this.attendee.attendeeStatus = AttendeeStatus.DISCONNECTING;
    } else {
      this.attendee.attendeeStatus = AttendeeStatus.DEPARTED;
      this.attendee.departure = new Date().toISOString();
    }

    this.attendee.inProcessing = true;

    if(presentationId && livePresentationId && this.attendee?.viewerId) {
      const content = {
        uniqueViewerId: this.attendee.viewerId
      };
      const body = createChangeConnectionStatusAttendeeCommandObject(
        content,
        livePresentationId,
        this.confirmationVariant === AttendeeConnectionVariant.DISCONNECT ? LiveCommands.DISCONNECT : LiveCommands.RECONNECT
      );
      sendChangeConnectionStatusAttendeeCommand(body);
    }

    this.confirmationVariant = null;
  };

  public closeConfirmationModal = (): void => {
    this.confirmationVariant = null;
    this.showConfirmationModal = false;
  };
}

export { AttendeeConnectionControlService };
